export const getCancelledWord = (input = '') => {
	if (input === '') {
		return '';
	}

	return input;
};
